<div class="mobile-shell" *ngIf="currentStep as step">
    <header class="mobile-header">
        <div class="mobile-header-top">
            <div class="mobile-title">
                <mat-icon color="accent">new_releases</mat-icon>
                <span class="mobile-title__label">Was ist neu?</span>
            </div>
            <div class="mobile-header-top__actions">
                <span class="step-counter">Schritt {{ step.globalStepNumber }} / {{ step.globalTotalSteps }}</span>
                <button
                    type="button"
                    class="mobile-header__close"
                    mat-icon-button
                    aria-label="Schließen"
                    (click)="spaeter()"
                >
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>
        <mat-progress-bar color="accent" mode="determinate" [value]="progressPercent"></mat-progress-bar>
        <div class="mobile-meta">
            <span class="version-badge">v{{ step.version }}</span>
            <span class="feature-badge">{{ step.featureTitle }}</span>
            <span *ngIf="step.totalStepsInFeature > 1" class="feature-step-badge">
                {{ step.stepNumber }}/{{ step.totalStepsInFeature }}
            </span>
        </div>
    </header>

    <div class="mobile-body">
        <h2 class="step-title">{{ step.title }}</h2>
        <p class="step-description">{{ step.description }}</p>

        <div class="media-area" *ngIf="step.image || step.video">
            <img
                *ngIf="step.image"
                [src]="step.image"
                [alt]="step.title"
                class="step-image step-image--expandable"
                role="button"
                tabindex="0"
                (click)="openImageFullscreen(step.image)"
                (keydown.enter)="openImageFullscreen(step.image)"
                (keydown.space)="openImageFullscreen(step.image); $event.preventDefault()"
            />

            <video *ngIf="step.video && !isYoutubeVideo(step.video)" class="step-video" controls playsinline>
                <source [src]="step.video" />
            </video>

            <iframe
                *ngIf="step.video && isYoutubeVideo(step.video)"
                class="step-video-embed"
                [src]="getYoutubeEmbedUrl(step.video)"
                title="Anleitungsvideo"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            ></iframe>
        </div>

        <button *ngIf="step.route" mat-stroked-button color="accent" class="route-button" (click)="tryRoute(step.route)">
            <mat-icon>open_in_new</mat-icon>
            Zum Bereich wechseln
        </button>

        <div class="step-dots" *ngIf="currentFeatureSteps.length > 1">
            <button
                *ngFor="let featureStep of currentFeatureSteps; let i = index"
                type="button"
                class="step-dot"
                [class.active]="i === currentFeatureStepIndex"
                [class.completed]="i < currentFeatureStepIndex"
                [attr.aria-label]="'Schritt ' + featureStep.stepNumber"
                (click)="goToFeatureStep(i)"
            ></button>
        </div>
    </div>

    <footer class="mobile-footer">
        <button mat-button type="button" class="footer-btn" [disabled]="isFirstStep" (click)="previous()">Zurück</button>
        <button *ngIf="!isLastStep" mat-flat-button color="accent" type="button" class="footer-btn footer-btn--primary" (click)="next()">
            Weiter
        </button>
        <button *ngIf="isLastStep" mat-flat-button color="accent" type="button" class="footer-btn footer-btn--primary" (click)="verstanden()">
            Verstanden
        </button>
    </footer>
</div>

<div
    *ngIf="fullscreenImageUrl"
    class="image-fullscreen-overlay"
    role="dialog"
    aria-modal="true"
    aria-label="Bild in Vollbild"
    (click)="closeImageFullscreen()"
>
    <button
        type="button"
        class="image-fullscreen-close"
        mat-icon-button
        aria-label="Schließen"
        (click)="closeImageFullscreen(); $event.stopPropagation()"
    >
        <mat-icon>close</mat-icon>
    </button>
    <img
        [src]="fullscreenImageUrl"
        alt=""
        class="image-fullscreen-img"
        (click)="closeImageFullscreen(); $event.stopPropagation()"
    />
</div>
